import React from "react";
import useSorting from "./useSorting";

/**
 * Higher Order Component that provides sorting functionality to a component
 * @param {React.Component} WrappedComponent - The component to wrap
 * @param {Object} options - Options for the sorting
 * @param {Function} options.getSortValue - Function to get the value to sort by from an item and column index
 * @param {Function} options.getDefaultSortValue - Function to get the default sort value from an item
 * @returns {React.Component} - The wrapped component with sorting props
 */
const withSorting = (WrappedComponent, options = {}) => {
  // Return a functional component
  return function WithSortingComponent(props) {
    // Use the sorting hook
    const { sortBy, sortDirection, handleSort, sortItems } = useSorting(
      options
    );

    // Pass the sorting props to the wrapped component
    return (
      <WrappedComponent
        {...props}
        sortBy={sortBy}
        sortDirection={sortDirection}
        handleSort={handleSort}
        sortItems={sortItems}
      />
    );
  };
};

export default withSorting;
